import React, {createContext, useState} from "react";
import PMSPatientServices from "../../services/pms_services/PMSPatientServices";
import Notification from "../../components/common/Notification";

export const PMSPatientContext = createContext("PMSPatientContext");

const PMSPatientContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [totalElements, setTotalElements] = useState(0);
    const [patients, setPatients] = useState([]);
    const [patient, setPatient] = useState(null);

    const handleError = (error) => {
        setLoading(false);
        let _error = "Something went wrong.";
        if (error.message === "Network Error") _error = error.message;
        if (error.response && error.response.data) _error = error.response.data.message;
        setErrorMsg(_error);
        Notification("error", "ERROR", `${_error}`);
        return false;
    };

    const getAllPatientsByPharmacyId = async (pharmacyId, params) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSPatientServices.getAllPatientsByPharmacyId(pharmacyId, params);
            setPatients(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoading(false);
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const getPatientById = async (pharmacyId, id) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSPatientServices.getPatientById(pharmacyId, id);
            setPatient(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const createPatient = async (pharmacyId, data) => {
        try {
            setLoading(true);
            await PMSPatientServices.createPatient(pharmacyId, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Patient created successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const updatePatientById = async (id, pharmacyId, data) => {
        try {
            setLoading(true);
            await PMSPatientServices.updatePatientById(id, pharmacyId, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Patient updated successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const deletePatientById = async (id) => {
        try {
            setLoading(true);
            await PMSPatientServices.deletePatientById(id);
            setLoading(false);
            Notification("success", "SUCCESS", "Patient deleted successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    return (
        <PMSPatientContext.Provider
            value={{
                loading,
                errorMsg,
                totalElements,
                patients,
                patient,
                getAllPatientsByPharmacyId,
                getPatientById,
                createPatient,
                updatePatientById,
                deletePatientById,
            }}
        >
            {children}
        </PMSPatientContext.Provider>
    );
};

export default PMSPatientContextProvider;
